import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import * as LucideIcons from "lucide-react";

const PolicySection = ({ title, content, icon, index }) => {
  const IconComponent = LucideIcons[icon];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Card
        sx={{
          height: "100%",
          transition: "box-shadow 0.3s",
          "&:hover": { boxShadow: 6 },
        }}
      >
        <CardHeader
          title={
            <Typography
              variant="h6"
              component="div"
              sx={{ display: "flex", alignItems: "center", color: "#151C62" }}
            >
              {IconComponent && (
                <IconComponent
                  size={24}
                  style={{ marginRight: 8, color: "#151C62" }}
                />
              )}
              {title}
            </Typography>
          }
        />
        <CardContent>
          <Typography sx={{ color: "black" }}>{content}</Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default PolicySection;
